import {getWithAuth, deleteWithAuth} from '@/api'
import {DossierBankAccount} from '@/stores/bank-accounts'

export const getDossierBankAccounts = () =>
    getWithAuth<DossierBankAccount[]>('/oppapi/v1/merchant-info/bank-accounts')

export const deleteDossierBankAccount = (id: number, dossierId: string) =>
    deleteWithAuth<{id: string; businessKey: string; status: string}>(
        `/oppapi/v1/merchant-info/bank-accounts/${id}?dossierId=${dossierId}`
    )
